import { render, staticRenderFns } from "./GlobalLargeSpotlight.vue?vue&type=template&id=2fcf9f68&scoped=true"
import script from "./GlobalLargeSpotlight.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalLargeSpotlight.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalLargeSpotlight.vue?vue&type=style&index=0&id=2fcf9f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcf9f68",
  null
  
)

export default component.exports